<template>
  <el-container direction="vertical">
    <VisitorHeader />
    <el-container>
      <div class="privacy-container">
        <p class="c90"><span class="c1">PRIVACY POLICY </span></p>
        <p class="c25"><span class="c0">EFFECTIVE DATE: August 5, 2019 </span></p>
        <p class="c97"><span class="c0">This Privacy Policy (“</span><span class="c16">Privacy Policy</span><span class="c0">”) describes how </span><span class="c1">A</span><span class="c19">UDIO </span><span class="c1">T</span><span class="c19">EST </span><span class="c1">K</span><span class="c19">ITCHEN</span><span class="c1">,I</span><span class="c19">NC</span><span class="c1">.</span><span class="c0">, a Delaware corporation (“</span><span class="c16">ATK</span><span class="c0">”, &nbsp;“we,” “us,” or “our”), collects, uses, and discloses the information that we obtain about visitors to our website, audiotestkitchen.com, app.audiotestkitchen.com and related domains and subdomains (collectively, the “</span><span class="c16">Site</span><span class="c0">”), and &nbsp;subscribers to our mailing list (“</span><span class="c16">Mailing List</span><span class="c0">”), and the information and services available through our Site and &nbsp;mailing list communications (collectively, the “</span><span class="c16">Services</span><span class="c0">”). </span></p>
        <p class="c71"><span class="c0">By visiting the Site, or using any of our Services, you agree that your personal information will be handled as described &nbsp;in this Privacy Policy. Your use of our Site or Services, and any dispute over privacy, is subject to this Privacy Policy &nbsp;and the Audio Test Kitchen, Inc. Website Terms of Use (including its applicable limitations on damages and the &nbsp;resolution of disputes) (“</span><span class="c16">Terms of Use</span><span class="c0">”), a copy of which can be found here: &nbsp;https://app.audiotestkitchen.com/assets/terms/terms_and_conditions_normal.pdf. The Terms of Use are incorporated &nbsp;by reference into this Privacy Policy. </span></p>
        <p class="c7"><span class="c5">The Information We Collect About You</span><span class="c1">&nbsp;</span></p>
        <p class="c29"><span class="c0">We collect information about you directly from you and from third parties, and automatically through your use of our &nbsp;Site or Services. </span></p>
        <p class="c63"><span class="c5">Information We Collect Directly From You</span><span class="c1">&nbsp;</span></p>
        <p class="c100"><span class="c0">The information we collect from you depends on how you use our Services. To create an account, you must provide &nbsp;your Name, email and passcode. To sign up for the Mailing List, you must either opt-in when you create an account, &nbsp;or provide us with your email via another channel in which you expressly sign-up to the Mailing List. </span></p>
        <p class="c31"><span class="c5">Information We Collect Automatically</span><span class="c1">&nbsp;</span></p>
        <p class="c10"><span class="c0">We automatically collect information about your use of our Site and Apps through cookies, web beacons, and other &nbsp;technologies, including technologies designed for mobile apps. To the extent permitted by applicable law, we combine &nbsp;this information with other information we collect about you, including your personal information. Please see the &nbsp;section “Cookies and Other Tracking Mechanisms” below for more information. </span></p>
        <p class="c93"><span class="c11">Site</span><span class="c21">: </span></p>
        <p class="c65"><span class="c0">• domain name; </span></p>
        <p class="c27"><span class="c0">• your browser type and operating system; </span></p>
        <p class="c44"><span class="c0">• web pages you view on the Site; links you click on the Site; your IP address; </span></p>
        <p class="c44"><span class="c0">• the length of time you visit our Site and or use our Services; </span></p>
        <p class="c27"><span class="c0">• the referring URL, or the webpage that led you to our Site. </span></p>
        <p class="c32"><span class="c11">App</span><span class="c21">: </span></p>
        <p class="c65"><span class="c0">• device name and model; operating system type, name, and version; </span></p>
        <p class="c44"><span class="c0">• language information; </span></p>
        <p class="c44"><span class="c0">• activities within the App; </span></p>
        <p class="c67"><span class="c5">How We Use Your Information</span><span class="c1">&nbsp;</span></p>
        <p class="c78"><span class="c0">We use your information, including your personal information, for the following purposes: • To provide our Services to you.</span></p>
        <p class="c46"><span class="c0">• To communicate with you about your use of our Services, to respond to your inquiries, and for other customer &nbsp;service purposes. &nbsp;</span></p>
        <p class="c55"><span class="c0">• To tailor the content and information that we may send or display to you, to offer location customization, and &nbsp;personalized help and instructions, and to otherwise personalize your experiences while using the Services. • To send you email marketing about our products and services (Mailing List subscribers only). &nbsp;• To send you news and newsletters (Mailing List subscribers only). </span></p>
        <p class="c34"><span class="c0">• To send you email marketing about products and services of our affiliated entities (Mailing List subscribers &nbsp;only). </span></p>
        <p class="c8"><span class="c0">• To send you email marketing about products and services of other entities that we think may be of interest to &nbsp;you (Mailing List subscribers only). </span></p>
        <p class="c36"><span class="c0">• To assist us in advertising on third party websites, mobile apps, and other online services, and to evaluate the &nbsp;success of our adverting campaigns through third party channels (including our online targeted advertising &nbsp;and offline promotional campaigns). </span></p>
        <p class="c64"><span class="c0">• To better understand how users access and use our Services, both on an aggregated and individualized basis. &nbsp;For example, we will evaluate which features of our Site and App are more (or least) used by users, and we &nbsp;will use this information. &nbsp;</span></p>
        <p class="c18"><span class="c0">• For research and analytics purposes. </span></p>
        <p class="c27"><span class="c0">• To administer our customer loyalty program. &nbsp;</span></p>
        <p class="c20"><span class="c0">• To administer surveys and questionnaires, such as for market research or member satisfaction purposes. • To comply with legal obligations, as part of our general business operations, and for other business &nbsp;administration purposes. </span></p>
        <p class="c73"><span class="c0">• Where we believe necessary to investigate, prevent or take action regarding illegal activities, suspected fraud, &nbsp;situations involving potential threats to the safety of any person or violations of our Terms of Use or this &nbsp;Privacy Policy. </span></p>
        <p class="c7"><span class="c5">How We Share Your Information</span><span class="c1">&nbsp;</span></p>
        <p class="c84"><span class="c0">We may share your information, including personal information, as follows: </span></p>
        <p class="c28"><span class="c0">• </span><span class="c16">Service Providers</span><span class="c0">. We disclose the information we collect from you to service providers, contractors or &nbsp;agents who perform functions on our behalf. </span></p>
        <p class="c60"><span class="c0">• </span><span class="c16">Affiliates</span><span class="c0">. We disclose the information we collect from you to our affiliates or subsidiaries. &nbsp;</span></p>
        <p class="c53"><span class="c0">• </span><span class="c16">Facebook Users</span><span class="c0">. Your username and profile picture will be visible to all other ATK users, regardless of &nbsp;whether they are your Facebook friends. In addition, when you join ATK, if you grant us permission to post &nbsp;on your Wall, a notification will be visible on your Facebook page telling your friends that you have started &nbsp;using ATK. The ATK Application also will be visible on your Facebook page under “applications.” </span></p>
        <p class="c95"><span class="c0">• </span><span class="c16">ATK Users</span><span class="c15">. </span><span class="c0">Your user name and any information that you post to our Site, including, without limitation, &nbsp;reviews, comments, and text will be available to, and searchable by, all users of the Site and Services. &nbsp;</span></p>
        <p class="c35"><span class="c0">We also disclose information in the following circumstances: </span></p>
        <p class="c66"><span class="c0">• </span><span class="c16">Business Transfers</span><span class="c15">. </span><span class="c0">If (i) we or our affiliates are or may be acquired by, merged with, or invested in by &nbsp;another company, or (ii) if any of our assets are or may be transferred to another company, whether as part &nbsp;of a bankruptcy or insolvency proceeding or otherwise, we may transfer the information we have collected &nbsp;from you to the other company. As part of the business transfer process, we may share certain of your &nbsp;personal information with lenders, auditors, and third-party advisors, including attorneys and consultants. </span></p>
        <p class="c88"><span class="c0">• </span><span class="c16">In Response to Legal Process</span><span class="c0">. We disclose your information to comply with the law, a judicial proceeding, &nbsp;court order, or other legal process, such as in response to a court order or a subpoena. </span></p>
        <p class="c26"><span class="c0">• </span><span class="c16">To Protect Us and Others. </span><span class="c0">We disclose your information when we believe it is appropriate to do so to &nbsp;investigate, prevent, or take action regarding illegal activities, suspected fraud, situations involving potential </span></p>
        <p class="c68"><span class="c0">threats to the safety of any person, violations of our Terms of Use or this Privacy Policy, or as evidence in &nbsp;litigation in which we are involved. </span></p>
        <p class="c48"><span class="c0">• </span><span class="c16">Aggregate and De-Identified Information</span><span class="c0">. We share aggregate, anonymized, or de-identified information &nbsp;about users with third parties for marketing, advertising, research or similar purposes. </span></p>
        <p class="c3"><span class="c5">Our Use of Cookies and Other Tracking Mechanisms</span><span class="c1">&nbsp;</span></p>
        <p class="c9"><span class="c0">We and our third-party service providers may use cookies and other tracking mechanisms to track information about &nbsp;your use of our Site or Services. We may combine this information with other personal information we collect from &nbsp;you (and our third-party service providers may do so on our behalf). &nbsp;</span></p>
        <p class="c56"><span class="c5">Cookies</span><span class="c0">. Cookies are alphanumeric identifiers that we transfer to your device’s hard drive through your web browser &nbsp;for record-keeping purposes. Some cookies allow us to make it easier for you to navigate our Site and Services, while &nbsp;others are used to enable a faster log-in process or to allow us to track your activities at our Site and Service. There &nbsp;are two types of cookies: session and persistent cookies. </span></p>
        <p class="c57"><span class="c0">• </span><span class="c5">Session Cookies</span><span class="c0">. Session cookies exist only during an online session. They disappear from your device when &nbsp;you close your browser or turn off your device. We use session cookies to allow our systems to uniquely &nbsp;identify you during a session or while you are logged into the Site and Services. This allows us to process &nbsp;your online transactions and requests and verify your identity, after you have logged in, as you move through &nbsp;our Site and Services. </span></p>
        <p class="c42"><span class="c0">• </span><span class="c5">Persistent Cookies</span><span class="c0">. Persistent cookies remain on your device after you have closed your browser or turned &nbsp;off your device. We use persistent cookies to track aggregate and statistical information about user activity. &nbsp;</span></p>
        <p class="c82"><span class="c5">Disabling Cookies</span><span class="c0">. Most web browsers automatically accept cookies, but if you prefer, you can edit your browser &nbsp;options to block them in the future. The Help portion of the toolbar on most browsers will tell you how to prevent &nbsp;your computer from accepting new cookies, how to have the browser notify you when you receive a new cookie, or &nbsp;how to disable cookies altogether. Visitors to our Site and Services who disable cookies will be able to browse certain &nbsp;areas of the Site, but some features may not function. </span></p>
        <p class="c81"><span class="c5">Flash Local Storage Objects</span><span class="c0">. We may use Flash Local Storage Objects (“</span><span class="c16">Flash LSOs</span><span class="c0">”) to store your Site preferences &nbsp;and to personalize your visit. Flash LSOs are different from browser cookies because of the amount and type of data &nbsp;stored. Typically, you cannot control, delete, or disable the acceptance of Flash LSOs through your web browser. For &nbsp;more information on Flash LSOs, or to learn how to manage your settings for Flash LSOs, go to the Adobe Flash &nbsp;Player Help Page, choose “Global Storage Settings Panel” and follow the instructions. To see the Flash LSOs currently &nbsp;on your computer, choose “Website Storage Settings Panel” and follow the instructions to review and, if you choose, &nbsp;to delete any specific Flash LSO. </span></p>
        <p class="c30"><span class="c5">Clear Gifs, Pixel Tags and Other Technologies</span><span class="c0">. Clear GIFs are tiny graphics with a unique identifier, similar in &nbsp;function to cookies. In contrast to cookies, which are stored on your computer’s hard drive, clear GIFs are embedded &nbsp;invisibly on web and app pages. We may use clear GIFs (a.k.a. web beacons, web bugs or pixel tags), in connection &nbsp;with our Site and Services to, among other things, track the activities of Site visitors and app users, help us manage &nbsp;content, and compile statistics about Site usage. We and our third party service providers also use clear GIFs in HTML &nbsp;e-mails to our customers, to help us track e-mail response rates, identify when our e-mails are viewed, and track &nbsp;whether our e-mails are forwarded. </span></p>
        <p class="c50"><span class="c5">Third Party Analytics</span><span class="c0">. We use automated devices and applications, such as Google Analytics, to evaluate usage of &nbsp;our Site, and to the extent permitted, our Apps. We also may use other analytic means to evaluate our Site and Apps. &nbsp;We use these tools to help us improve our Site’s and Apps’ performance and user experiences. These entities may use &nbsp;cookies and other tracking technologies, such as web beacons or local storage objects (LSOs), to perform their &nbsp;services. To learn more about Google’s privacy practices, please review the Google Privacy Policy at &nbsp;https://www.google.com/policies/privacy/. You can also download the Google Analytics Opt-out Browser Add-on to &nbsp;prevent their data from being used by Google Analytics at https://tools.google.com/dlpage/gaoptout.</span></p>
        <p class="c2"><span class="c5">Do-Not-Track</span><span class="c0">. Currently, our systems do not recognize browser “do-not-track” requests. You may, however, disable &nbsp;certain tracking as discussed in this section (e.g., by disabling cookies); you also may opt-out of targeted advertising &nbsp;by following the instructions in the Third-Party Ad Network section. </span></p>
        <p class="c7"><span class="c5">Third-Party Ad Networks</span><span class="c1">&nbsp;</span></p>
        <p class="c94"><span class="c0">We may use third parties such as network advertisers to help serve advertisements on our Site, App, and on third-party &nbsp;websites or other media (e.g., social networking platforms). This enables us and these third parties to target &nbsp;advertisements to you for products and services in which you might be interested. Third-party ad network providers, &nbsp;advertisers, sponsors and/or traffic measurement services may use cookies, JavaScript, web beacons (including clear &nbsp;GIFs), Flash LSOs and other tracking technologies to measure the effectiveness of their ads and to personalize &nbsp;advertising content to you. These third-party cookies and other technologies are governed by each third party's specific &nbsp;privacy policy, not this one. We may provide these third-party advertisers with information, including personal &nbsp;information, about you. </span></p>
        <p class="c80"><span class="c0">Users in the United States may opt out of many third-party ad networks. For example, you may go to the Digital &nbsp;Advertising Alliance (&quot;</span><span class="c16">DAA</span><span class="c0">&quot;) </span><span class="c23">Consumer Choice Page </span><span class="c0">for information about opting out of interest-based advertising &nbsp;and their choices regarding having information used by </span><span class="c23">DAA companies</span><span class="c0">. You may also go to the Network Advertising &nbsp;Initiative (&quot;</span><span class="c16">NAI</span><span class="c0">&quot;) </span><span class="c23">Consumer Opt-Out Page </span><span class="c0">for information about opting out of interest-based advertising and their &nbsp;choices regarding having information used by </span><span class="c23">NAI members</span><span class="c0">. </span></p>
        <p class="c14"><span class="c0">Opting out from one or more companies listed on the DAA </span><span class="c23">Consumer Choice Page </span><span class="c0">or the NAI </span><span class="c23">Consumer Opt-Out</span><span class="c47">&nbsp; </span><span class="c23">Page </span><span class="c0">will opt you out from those companies' delivery of interest-based content or ads to you, but it does not mean you &nbsp;will no longer receive any advertising through our Site, Services, or on other websites. You may continue to receive &nbsp;advertisements, for example, based on the particular website that you are viewing (i.e., contextually based ads). Also, &nbsp;if your browsers are configured to reject cookies when you opt out on the DAA or NAI websites, your opt out may &nbsp;not be effective. Additional information is available on the DAA's website at www.aboutads.info or the NAI's website &nbsp;at www.networkadvertising.org. </span></p>
        <p class="c7"><span class="c5">Third-Party Links</span><span class="c1">&nbsp;</span></p>
        <p class="c85"><span class="c0">Our Site and Services may contain links to third-party websites. Any access to and use of such linked websites is not &nbsp;governed by this Privacy Policy, but instead is governed by the privacy policies of those third-party websites. We are &nbsp;not responsible for the information practices of such third-party websites. </span></p>
        <p class="c37"><span class="c5">Security of My Personal Information</span><span class="c1">&nbsp;</span></p>
        <p class="c83"><span class="c0">We have implemented reasonable precautions to protect the information that we collect from loss, misuse, and &nbsp;unauthorized access, disclosure, alteration, and destruction. Please be aware that despite our best efforts, no data &nbsp;security measures can guarantee security. </span></p>
        <p class="c101"><span class="c0">You should take steps to protect against unauthorized access to your password, phone, and computer by, among other &nbsp;things, signing off after using a shared computer, choosing a robust password that nobody else knows or can easily &nbsp;guess, and keeping your log-in and password private. We are not responsible for any lost, stolen, or compromised &nbsp;passwords or for any activity on your account via unauthorized password activity. </span></p>
        <p class="c7"><span class="c5">Access To My Personal Information</span><span class="c1">&nbsp;</span></p>
        <p class="c58"><span class="c0">You may modify personal information that you have submitted by logging into your account and updating your profile &nbsp;information. Please note that copies of information that you have updated, modified or deleted may remain viewable &nbsp;in cached and archived pages of the Site for a period of time. </span></p>
        <p class="c7"><span class="c5">What Choices Do I Have Regarding Use of My Personal Information</span><span class="c1">? </span></p>
        <p class="c13"><span class="c0">In accordance with applicable law, we may send periodic promotional emails to you if you are a Mailing List &nbsp;Subscriber. You may opt-out of promotional emails by following the opt-out instructions contained in the email. Please </span></p>
        <p class="c96"><span class="c0">note that it may take up to 10 business days for us to process opt-out requests. If you opt-out of receiving promotional &nbsp;emails, we may still send you emails about your account or any services you have requested or received from us. </span></p>
        <p class="c37"><span class="c5">Children Under 13</span><span class="c1">&nbsp;</span></p>
        <p class="c38"><span class="c0">Our Services are not designed for children under 13. If we discover that a child under 13 has provided us with personal &nbsp;information, we will delete such information from our systems. </span></p>
        <p class="c37"><span class="c5">Special Information for California Consumers</span><span class="c1">&nbsp;</span></p>
        <p class="c87"><span class="c0">California residents may request a list of certain third parties to which we have disclosed personally identifiable &nbsp;information about you for their own direct marketing purposes. You may make one request per calendar year. In your &nbsp;request, please attest to the fact that you are a California resident and provide a current California address for your &nbsp;response. You may request this information in writing by contacting us at: privacy@audiotestkitchen.com. Please &nbsp;allow up to thirty (30) days for a response. </span></p>
        <p class="c37"><span class="c5">Contact Us</span><span class="c1">&nbsp;</span></p>
        <p class="c12"><span class="c0">If you have questions about the privacy aspects of our Services or would like to make a complaint, please contact us &nbsp;at privacy@audiotestkitchen.com. </span></p>
        <p class="c3"><span class="c5">Changes to this Privacy Policy</span><span class="c1">&nbsp;</span></p>
        <p class="c52"><span class="c0">This Privacy Policy is current as of the Effective Date set forth above. We may change this Privacy Policy from time &nbsp;to time, so please be sure to check back periodically. We will post any changes to this Privacy Policy on our Site and &nbsp;Application. If we make any changes to this Privacy Policy that materially affect our practices with regard to the &nbsp;personal information we have previously collected from you, we will endeavor to provide you with notice in advance &nbsp;of such change by highlighting the change on our Site and Application. </span></p>
        <p class="c51"><span class="c5">Additional Information for EU Individuals</span><span class="c1">&nbsp;</span></p>
        <p class="c102"><span class="c0">The information we collect through the Services is controlled by ATK which is headquartered in the United States at &nbsp;4365 Elenda Street, Culver City, CA 90230. </span></p>
        <p class="c24"><span class="c4">The Legal Bases for Using Your Personal Information</span><span class="c0">. We collect your information as a data controller when we have &nbsp;a legal basis to do so. The following legal bases pertain to our collection of data: </span></p>
        <p class="c45"><span class="c0">• Our use of your personal information is in our legitimate interest as a commercial organization (for example &nbsp;in order to make improvements to our products and services and to provide you with information you &nbsp;request); you have a right to object to processing as explained in the section below entitled Your Legal Rights; </span></p>
        <p class="c61"><span class="c0">• Our use of your personal information is necessary to perform our agreement with you or take steps to enter &nbsp;into an agreement with you (for example, to facilitate your use of the site or receipt of the Mailing List, where &nbsp;we use your personal information to respond to your customer service requests, to provide our services &nbsp;through our Site or Apps); and/or </span></p>
        <p class="c89"><span class="c0">• Our use of your personal information is necessary to comply with a relevant legal or regulatory obligation &nbsp;that we have (for example, where we are required to disclose personal information to a court or tax authority); </span></p>
        <p class="c69"><span class="c0">• Our use of your personal information is in accordance with your consent (for example, when you consent to &nbsp;sharing your personal information with a third party for their own marketing); and/or </span></p>
        <p class="c22"><span class="c0">• Our use is necessary to protect your vital interests (for example, to notify you of the occurrence of a data &nbsp;breach). </span></p>
        <p class="c75"><span class="c0">If you would like to find out more about the legal bases on which we process personal information, please contact us &nbsp;using the details below.</span></p>
        <p class="c91"><span class="c4">Retention of Your Personal Information</span><span class="c0">. We retain your personal information for as long as necessary to provide our &nbsp;services to you, to fulfil the purposes described in this Privacy Policy and/or our business purposes, or as required by &nbsp;law, regulation, or internal policy. </span></p>
        <p class="c70"><span class="c4">Processing of Information from Children Between the Ages of 14 and 17</span><span class="c0">. Where a child in the EU between the ages &nbsp;of 14 and 17 provides us with personal information through the Services and our processing is based on consent as a &nbsp;legal basis, we will obtain the consent of the child’s respective parent or guardian. The parent or guardian has the right &nbsp;to withdraw such consent provided on behalf of their child at any time. </span></p>
        <p class="c77"><span class="c4">Your Legal Rights</span><span class="c0">. Subject to certain exemptions, and in some cases dependent upon the processing activity we are &nbsp;undertaking, when ATK acts as a data controller, European Union individuals have certain rights in relation to their &nbsp;personal information: </span></p>
        <p class="c92"><span class="c4">Right to Access, Correct, and Delete your Personal Information</span><span class="c0">: You have the right to request access to the personal &nbsp;information that we hold about you and: (a) the source of your personal information; (b) the purposes, legal basis and &nbsp;methods of processing; (c) the data controller’s identity; and (d) the entities or categories of entities to whom your &nbsp;personal information may be transferred. </span></p>
        <p class="c51"><span class="c0">You also have the right to request that we delete your information. </span></p>
        <p class="c33"><span class="c0">We are not required to comply with your request to erase personal information if the processing of your personal &nbsp;information is necessary for compliance with a legal obligation or for the establishment, exercise, or defense of legal &nbsp;claims. </span></p>
        <p class="c41"><span class="c4">Right to restrict the processing of your personal information</span><span class="c0">: You have the right to restrict the use of your personal &nbsp;information when (i) you contest the accuracy of the data; (ii) the use is unlawful but you do not want us to erase the &nbsp;data; (iii) we no longer need the personal information for the relevant purposes, but we require it for the establishment, &nbsp;exercise, or defense of legal claims; or (iv) you have objected to our personal information use where such use is &nbsp;justified on our legitimate interests and we must verify as to whether we have a compelling interest to continue to use &nbsp;your data. </span></p>
        <p class="c99"><span class="c0">We can continue to use your personal information following a request for restriction, where: • we have your consent; or </span></p>
        <p class="c49"><span class="c0">• to establish, exercise or defend legal claims; or </span></p>
        <p class="c43"><span class="c0">• to protect the rights of another natural or legal person. </span></p>
        <p class="c76"><span class="c4">Right to data portability</span><span class="c0">: To the extent that we process your information (i) based on your consent or under a contract; &nbsp;and (ii) through automated means, you have the right to receive such personal information in a structured, commonly &nbsp;used, machine-readable format, or you can ask to have it transferred directly to another data controller. </span></p>
        <p class="c39"><span class="c4">Right to object to the processing of your personal information</span><span class="c0">: You can object to any processing of your personal &nbsp;information which has our legitimate interests as its legal basis, if you believe your fundamental rights and freedoms &nbsp;outweigh our legitimate interests. If you raise an objection, we have an opportunity to demonstrate that we have &nbsp;compelling legitimate interests which override your rights and freedoms. </span></p>
        <p class="c98"><span class="c4">Right to obtain a copy of personal information safeguards used for transfers outside your jurisdiction</span><span class="c0">: You </span><span class="c4">c</span><span class="c0">an ask to &nbsp;obtain a copy of, or reference to, the safeguards under which your personal information is transferred outside of the &nbsp;EEA. </span></p>
        <p class="c62"><span class="c4">Right to lodge a complaint with your local supervisory authority</span><span class="c0">: You have a right to lodge a complaint with your &nbsp;local supervisory authority if you have concerns about how we are processing your personal information. </span></p>
        <p class="c6"><span class="c0">We ask that you please attempt to resolve any issues with us first, although you have a right to contact your supervisory &nbsp;authority at any time. </span></p>
        <p class="c79"><span class="c4">How to Exercise Your Rights</span><span class="c0">: If you would like to exercise any of the rights described above, please send us a request &nbsp;at privacy@audiotestkitchen.com. In your message, please indicate the right you would like to exercise and the &nbsp;information that you would like to access, review, correct, or delete. </span></p>
        <p class="c54"><span class="c0">We may ask you for additional information to confirm your identity and for security purposes before disclosing the &nbsp;personal information requested to you. We reserve the right to charge a fee where permitted by law, for instance if &nbsp;your request is manifestly unfounded or excessive. </span></p>
        <p class="c86"><span class="c0">We may not always be able to fully address your request, for example if it would affect the duty of confidentiality we &nbsp;owe to others or if we are legally entitled to deal with the request in a different way. </span></p>
        <p class="c40"><span class="c4">Cross-border Transfer of Information</span><span class="c0">. We generally maintain servers and systems in the United States hosted by third &nbsp;party service providers. As a result, where the personal information that we collect through or in connection with the &nbsp;Site, App, or our services, or is provided to us by our franchisees, is transferred to and processed in the United States &nbsp;or anywhere else outside the European Economic Area (EEA) for the purposes described above, we will take steps to &nbsp;ensure that the information receives the same level of protection as if it remained within the EEA, including entering &nbsp;into data transfer agreements, or using the EU Commission approved Standard Contractual Clauses. You may have a &nbsp;right to details of the mechanisms under which your data is transferred outside the EEA. </span></p>
        <p class="c72"><span class="c0">We comply with the E.U. – U.S. and Swiss – U.S. Privacy Shield Frameworks as set forth by the U.S. Department of &nbsp;Commerce regarding the collection, use, and retention of personal information obtained from European Union member &nbsp;countries and Switzerland and transferred to the United States. For information on how we process personal &nbsp;information transferred from the European Union and Switzerland, under the Privacy Shield Principles, please see our &nbsp;Privacy Shield Notice or visit the Privacy Shield website at https://www.privacyshield.gov/. </span></p>
      </div>
    </el-container>
  </el-container>
</template>

<script>
import VisitorHeader from '@/components/layouts/visitor/Header'
export default {
  name: 'Privacy',
  components: {
    VisitorHeader
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.privacy-container {
  padding: 170px 0 110px;
  width: 800px;
  max-width: 100%;
  margin: auto;
}

ol {
  margin: 0;
  padding: 0;
}

table td,table th {
  padding: 0;
}

.c23 {
  -webkit-text-decoration-skip: none;
  color: #0000ff;
  font-weight: 400;
  text-decoration: underline;
  vertical-align: baseline;
  text-decoration-skip-ink: none;
  font-size: 10.1pt;
  font-family: "Lato";
  font-style: normal;
}

.c11 {
  -webkit-text-decoration-skip: none;
  color: #4a4a4a;
  font-weight: 700;
  text-decoration: underline;
  vertical-align: baseline;
  text-decoration-skip-ink: none;
  font-size: 10.1pt;
  font-family: "Lato";
  font-style: normal;
}

.c5 {
  -webkit-text-decoration-skip: none;
  color: #000000;
  font-weight: 700;
  text-decoration: underline;
  vertical-align: baseline;
  text-decoration-skip-ink: none;
  font-size: 10.1pt;
  font-family: "Lato";
  font-style: normal;
}

.c4 {
  -webkit-text-decoration-skip: none;
  color: #000000;
  font-weight: 400;
  text-decoration: underline;
  vertical-align: baseline;
  text-decoration-skip-ink: none;
  font-size: 10.1pt;
  font-family: "Lato";
  font-style: normal;
}

.c26 {
  margin-left: 36.8pt;
  padding-top: 13pt;
  text-indent: -17.7pt;
  padding-bottom: 0pt;
  line-height: 0.9520014524459839;
  text-align: left;
  margin-right: 0.2pt;
}

.c1 {
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10.1pt;
  font-family: "Lato";
  font-style: normal;
}

.c42 {
  margin-left: 36.8pt;
  padding-top: 12.7pt;
  text-indent: -17.7pt;
  padding-bottom: 0pt;
  line-height: 0.9718353748321533;
  text-align: left;
  margin-right: 0.3pt;
}

.c22 {
  margin-left: 36.6pt;
  padding-top: 11.3pt;
  text-indent: -17.5pt;
  padding-bottom: 0pt;
  line-height: 0.9520014524459839;
  text-align: left;
  margin-right: 0.3pt;
}

.c16 {
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10.1pt;
  font-family: "Lato";
  font-style: italic;
}

.c58 {
  margin-left: 0.8pt;
  padding-top: 9.8pt;
  text-indent: 0pt;
  padding-bottom: 0pt;
  line-height: 0.9519989490509033;
  text-align: justify;
  margin-right: 0.2pt;
}

.c36 {
  margin-left: 36.9pt;
  padding-top: 1.2pt;
  text-indent: -17.8pt;
  padding-bottom: 0pt;
  line-height: 0.9619137048721313;
  text-align: justify;
  margin-right: 0.2pt;
}

.c29 {
  margin-left: 1pt;
  padding-top: 9.8pt;
  text-indent: -0.4pt;
  padding-bottom: 0pt;
  line-height: 0.9520003199577332;
  text-align: left;
  margin-right: 0.1pt;
}

.c8 {
  margin-left: 36.7pt;
  padding-top: 1pt;
  text-indent: -17.6pt;
  padding-bottom: 0pt;
  line-height: 0.9520000219345093;
  text-align: left;
  margin-right: 0.3pt;
}

.c2 {
  margin-left: 0.6pt;
  padding-top: 0pt;
  text-indent: 0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9519974589347839;
  text-align: justify;
  margin-right: 0.2pt;
}

.c87 {
  margin-left: 0.6pt;
  padding-top: 9.6pt;
  text-indent: 0.2pt;
  padding-bottom: 0pt;
  line-height: 0.9569568634033203;
  text-align: justify;
  margin-right: 0.2pt;
}

.c46 {
  margin-left: 37.1pt;
  padding-top: 0pt;
  text-indent: -18pt;
  padding-bottom: 0pt;
  line-height: 0.9520000219345093;
  text-align: left;
  margin-right: 0.4pt;
}

.c56 {
  margin-left: 0.8pt;
  padding-top: 10.3pt;
  text-indent: 0.2pt;
  padding-bottom: 0pt;
  line-height: 0.9586091637611389;
  text-align: justify;
  margin-right: 0.3pt;
}

.c101 {
  margin-left: 0.6pt;
  padding-top: 10.3pt;
  text-indent: 0.2pt;
  padding-bottom: 0pt;
  line-height: 0.951999843120575;
  text-align: justify;
  margin-right: 0.1pt;
}

.c77 {
  margin-left: 0.6pt;
  padding-top: 10.3pt;
  text-indent: 0.2pt;
  padding-bottom: 0pt;
  line-height: 0.9520000219345093;
  text-align: justify;
  margin-right: 0.2pt;
}

.c92 {
  margin-left: 0.6pt;
  padding-top: 10.3pt;
  text-indent: 0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9586091637611389;
  text-align: justify;
  margin-right: 0.1pt;
}

.c86 {
  margin-left: 0.8pt;
  padding-top: 10.3pt;
  text-indent: -0.2pt;
  padding-bottom: 0pt;
  line-height: 0.9519949555397034;
  text-align: left;
  margin-right: 0.1pt;
}

.c14 {
  margin-left: 0.7pt;
  padding-top: 10.3pt;
  text-indent: 0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9520012140274048;
  text-align: justify;
  margin-right: 0.1pt;
}

.c64 {
  margin-left: 36.7pt;
  padding-top: 1.1pt;
  text-indent: -17.6pt;
  padding-bottom: 0pt;
  line-height: 0.9519974589347839;
  text-align: justify;
  margin-right: 0.3pt;
}

.c88 {
  margin-left: 36.8pt;
  padding-top: 12.7pt;
  text-indent: -17.7pt;
  padding-bottom: 0pt;
  line-height: 0.9519989490509033;
  text-align: left;
  margin-right: 0.3pt;
}

.c28 {
  margin-left: 36.9pt;
  padding-top: 10.8pt;
  text-indent: -17.8pt;
  padding-bottom: 0pt;
  line-height: 0.9520029425621033;
  text-align: left;
  margin-right: 0.3pt;
}

.c91 {
  margin-left: 0.7pt;
  padding-top: 0pt;
  text-indent: -0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9519974589347839;
  text-align: justify;
  margin-right: 0.2pt;
}

.c34 {
  margin-left: 36.8pt;
  padding-top: 0.6pt;
  text-indent: -17.7pt;
  padding-bottom: 0pt;
  line-height: 0.9718274474143982;
  text-align: left;
  margin-right: 0.2pt;
}

.c13 {
  margin-left: 1pt;
  padding-top: 9.6pt;
  text-indent: -0.3pt;
  padding-bottom: 0pt;
  line-height: 0.9718314409255981;
  text-align: left;
  margin-right: 0.2pt;
}

.c40 {
  margin-left: 0.6pt;
  padding-top: 10.3pt;
  text-indent: 0.2pt;
  padding-bottom: 0pt;
  line-height: 0.9553037285804749;
  text-align: justify;
  margin-right: 0.3pt;
}

.c61 {
  margin-left: 36.7pt;
  padding-top: 11.3pt;
  text-indent: -17.6pt;
  padding-bottom: 0pt;
  line-height: 0.9586106538772583;
  text-align: justify;
  margin-right: 0.1pt;
}

.c12 {
  margin-left: 0.9pt;
  padding-top: 9.6pt;
  text-indent: -0.2pt;
  padding-bottom: 0pt;
  line-height: 0.9718353748321533;
  text-align: left;
  margin-right: 0.2pt;
}

.c73 {
  margin-left: 36.7pt;
  padding-top: 0.7pt;
  text-indent: -17.6pt;
  padding-bottom: 0pt;
  line-height: 0.9520003199577332;
  text-align: justify;
  margin-right: 0.2pt;
}

.c102 {
  margin-left: 0.7pt;
  padding-top: 9.8pt;
  text-indent: 0pt;
  padding-bottom: 0pt;
  line-height: 0.9520003199577332;
  text-align: left;
  margin-right: 0.2pt;
}

.c45 {
  margin-left: 36.6pt;
  padding-top: 11.3pt;
  text-indent: -17.5pt;
  padding-bottom: 0pt;
  line-height: 0.9520016312599182;
  text-align: justify;
  margin-right: 0.1pt;
}

.c79 {
  margin-left: 0.7pt;
  padding-top: 0pt;
  text-indent: 0pt;
  padding-bottom: 0pt;
  line-height: 0.9519974589347839;
  text-align: justify;
  margin-right: 0.2pt;
}

.c39 {
  margin-left: 0.8pt;
  padding-top: 10.3pt;
  text-indent: -0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9586114287376404;
  text-align: justify;
  margin-right: 0.3pt;
}

.c48 {
  margin-left: 36.9pt;
  padding-top: 12.7pt;
  text-indent: -17.8pt;
  padding-bottom: 0pt;
  line-height: 0.9718325138092041;
  text-align: left;
  margin-right: 0.3pt;
}

.c68 {
  margin-left: 36.8pt;
  padding-top: 0pt;
  text-indent: -0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9520000219345093;
  text-align: left;
  margin-right: 0.3pt;
}

.c15 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10.1pt;
  font-family: "Lato";
  font-style: italic
}

.c66 {
  margin-left: 36.6pt;
  padding-top: 10.8pt;
  text-indent: -17.5pt;
  padding-bottom: 0pt;
  line-height: 0.9569582343101501;
  text-align: justify;
  margin-right: 0pt;
}

.c69 {
  margin-left: 37.1pt;
  padding-top: 11.1pt;
  text-indent: -18pt;
  padding-bottom: 0pt;
  line-height: 0.9519989490509033;
  text-align: left;
  margin-right: 0.3pt;
}

.c97 {
  margin-left: 0.7pt;
  padding-top: 9.6pt;
  text-indent: 0pt;
  padding-bottom: 0pt;
  line-height: 0.9569568634033203;
  text-align: left;
  margin-right: 0.2pt;
}

.c19 {
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 7.9pt;
  font-family: "Lato";
  font-style: normal
}

.c33 {
  margin-left: 0.8pt;
  padding-top: 9.8pt;
  text-indent: -0.2pt;
  padding-bottom: 0pt;
  line-height: 0.9520016312599182;
  text-align: justify;
  margin-right: 0pt;
}

.c83 {
  margin-left: 0.6pt;
  padding-top: 9.8pt;
  text-indent: -0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9520016312599182;
  text-align: justify;
  margin-right: 0.2pt;
}

.c82 {
  margin-left: 0.7pt;
  padding-top: 9.9pt;
  text-indent: 0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9569597244262695;
  text-align: justify;
  margin-right: 0.2pt;
}

.c50 {
  margin-left: 0.6pt;
  padding-top: 10.3pt;
  text-indent: 0.2pt;
  padding-bottom: 0pt;
  line-height: 0.9519997239112854;
  text-align: justify;
  margin-right: 0.1pt;
}

.c52 {
  margin-left: 0.6pt;
  padding-top: 9.8pt;
  text-indent: 0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9569597244262695;
  text-align: justify;
  margin-right: 0.2pt;
}

.c6 {
  margin-left: 0.9pt;
  padding-top: 10.3pt;
  text-indent: -0.3pt;
  padding-bottom: 0pt;
  line-height: 0.9519989490509033;
  text-align: left;
  margin-right: 0pt;
}

.c70 {
  margin-left: 0.7pt;
  padding-top: 10.3pt;
  text-indent: 0pt;
  padding-bottom: 0pt;
  line-height: 0.9519983530044556;
  text-align: justify;
  margin-right: 0.2pt;
}

.c89 {
  margin-left: 36.7pt;
  padding-top: 11pt;
  text-indent: -17.6pt;
  padding-bottom: 0pt;
  line-height: 0.9718340039253235;
  text-align: left;
  margin-right: 0.1pt;
}

.c53 {
  margin-left: 36.7pt;
  padding-top: 12.2pt;
  text-indent: -17.6pt;
  padding-bottom: 0pt;
  line-height: 0.9586129188537598;
  text-align: justify;
  margin-right: 0.2pt;
}

.c76 {
  margin-left: 0.7pt;
  padding-top: 9.8pt;
  text-indent: 0pt;
  padding-bottom: 0pt;
  line-height: 0.9520003199577332;
  text-align: justify;
  margin-right: 0.2pt;
}

.c96 {
  margin-left: 0.8pt;
  padding-top: 0pt;
  text-indent: 0pt;
  padding-bottom: 0pt;
  line-height: 0.9520000219345093;
  text-align: left;
  margin-right: 0.2pt;
}

.c57 {
  margin-left: 36.7pt;
  padding-top: 11pt;
  text-indent: -17.6pt;
  padding-bottom: 0pt;
  line-height: 0.9569589495658875;
  text-align: justify;
  margin-right: 0.3pt;
}

.c72 {
  margin-left: 0.7pt;
  padding-top: 10pt;
  text-indent: -0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9569591283798218;
  text-align: justify;
  margin-right: 0.1pt;
}

.c71 {
  margin-left: 0.6pt;
  padding-top: 10.3pt;
  text-indent: 0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9519979357719421;
  text-align: justify;
  margin-right: 0.2pt;
}

.c62 {
  margin-left: 0.8pt;
  padding-top: 10pt;
  text-indent: -0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9519989490509033;
  text-align: left;
  margin-right: 0.3pt;
}

.c21 {
  color: #4a4a4a;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10.1pt;
  font-family: "Lato";
  font-style: normal
}

.c24 {
  margin-left: 0.9pt;
  padding-top: 10.3pt;
  text-indent: -0.2pt;
  padding-bottom: 0pt;
  line-height: 0.9520003199577332;
  text-align: left;
  margin-right: 0.2pt;
}

.c30 {
  margin-left: 0.8pt;
  padding-top: 10.3pt;
  text-indent: 0.2pt;
  padding-bottom: 0pt;
  line-height: 0.9553056955337524;
  text-align: justify;
  margin-right: 0.2pt;
}

.c10 {
  margin-left: 0.6pt;
  padding-top: 9.8pt;
  text-indent: -0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9586120247840881;
  text-align: justify;
  margin-right: 0.3pt;
}

.c80 {
  margin-left: 0.7pt;
  padding-top: 10.1pt;
  text-indent: 0pt;
  padding-bottom: 0pt;
  line-height: 0.9569568634033203;
  text-align: justify;
  margin-right: 0.2pt;
}

.c99 {
  margin-left: 19.1pt;
  padding-top: 10pt;
  text-indent: -18.5pt;
  padding-bottom: 0pt;
  line-height: 1.8643357753753662;
  text-align: left;
  margin-right: 102.1pt;
}

.c9 {
  margin-left: 0.7pt;
  padding-top: 9.8pt;
  text-indent: -0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9520000219345093;
  text-align: justify;
  margin-right: 0.2pt;
}

.c81 {
  margin-left: 0.7pt;
  padding-top: 10.3pt;
  text-indent: 0pt;
  padding-bottom: 0pt;
  line-height: 0.9520012140274048;
  text-align: justify;
  margin-right: 0.2pt;
}

.c85 {
  margin-left: 0.7pt;
  padding-top: 9.8pt;
  text-indent: 0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9520003199577332;
  text-align: justify;
  margin-right: 0.2pt;
}

.c78 {
  margin-left: 19.1pt;
  padding-top: 9.8pt;
  text-indent: -18.5pt;
  padding-bottom: 0pt;
  line-height: 1.8643327951431274;
  text-align: left;
  margin-right: 108.2pt;
}

.c47 {
  color: #0000ff;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10.1pt;
  font-family: "Lato";
  font-style: normal
}

.c0 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10.1pt;
  font-family: "Lato";
  font-style: normal
}

.c38 {
  margin-left: 0.8pt;
  padding-top: 9.8pt;
  text-indent: 0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9519949555397034;
  text-align: left;
  margin-right: 0.4pt;
}

.c41 {
  padding-top: 10.3pt;
  text-indent: 0.7pt;
  padding-bottom: 0pt;
  line-height: 0.9559678435325623;
  text-align: justify;
  margin-right: 0.2pt;
}

.c54 {
  margin-left: 0.6pt;
  padding-top: 10.3pt;
  padding-bottom: 0pt;
  line-height: 0.9519974589347839;
  text-align: justify;
  margin-right: 0.2pt;
}

.c94 {
  margin-left: 0.6pt;
  padding-top: 9.8pt;
  padding-bottom: 0pt;
  line-height: 0.9548318386077881;
  text-align: justify;
  margin-right: 0.1pt;
}

.c55 {
  margin-left: 19.1pt;
  padding-top: 1.2pt;
  padding-bottom: 0pt;
  line-height: 1.0114974975585938;
  text-align: left;
  margin-right: 0.4pt;
}

.c20 {
  margin-left: 19.1pt;
  padding-top: 0.7pt;
  padding-bottom: 0pt;
  line-height: 1.0015854835510254;
  text-align: left;
  margin-right: 0.3pt;
}

.c98 {
  margin-left: 0.7pt;
  padding-top: 10pt;
  padding-bottom: 0pt;
  line-height: 0.9619165062904358;
  text-align: justify;
  margin-right: 0.1pt;
}

.c75 {
  margin-left: 0.7pt;
  padding-top: 10.3pt;
  text-indent: 0.1pt;
  padding-bottom: 0pt;
  line-height: 0.9519989490509033;
  text-align: left
}

.c100 {
  margin-left: 0.7pt;
  padding-top: 9.6pt;
  padding-bottom: 0pt;
  line-height: 0.9619191884994507;
  text-align: justify;
  margin-right: 0.3pt;
}

.c95 {
  margin-left: 19.1pt;
  padding-top: 12.7pt;
  padding-bottom: 0pt;
  line-height: 0.9718341827392578;
  text-align: center;
  margin-right: 0.1pt;
}

.c49 {
  margin-left: 19.1pt;
  padding-top: 2.1pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c60 {
  margin-left: 19.1pt;
  padding-top: 12.7pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c44 {
  margin-left: 19.1pt;
  padding-top: 0.7pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c18 {
  margin-left: 19.1pt;
  padding-top: 1.2pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c84 {
  margin-left: 0.6pt;
  padding-top: 9.8pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c43 {
  margin-left: 19.1pt;
  padding-top: 10.8pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c63 {
  margin-left: 0.7pt;
  padding-top: 10.3pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c67 {
  margin-left: 0.8pt;
  padding-top: 9.8pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c65 {
  margin-left: 19.1pt;
  padding-top: 14.6pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c93 {
  margin-left: 0.9pt;
  padding-top: 14.1pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c51 {
  margin-left: 0.8pt;
  padding-top: 10pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c3 {
  margin-left: 0.9pt;
  padding-top: 9.9pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c35 {
  margin-left: 0.6pt;
  padding-top: 9.9pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c37 {
  margin-left: 0.9pt;
  padding-top: 10.3pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c7 {
  margin-left: 0.8pt;
  padding-top: 10.3pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c25 {
  margin-left: 0.7pt;
  padding-top: 9.8pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c32 {
  margin-left: 0.8pt;
  padding-top: 13.9pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c31 {
  margin-left: 0.7pt;
  padding-top: 10pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c27 {
  margin-left: 19.1pt;
  padding-top: 1pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: left
}

.c90 {
  padding-top: 9.8pt;
  padding-bottom: 0pt;
  line-height: 1.0;
}

.c17 {
  padding-top: 31.6pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: center
}

.c74 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.0;
  text-align: center
}

.c59 {
  background-color: #ffffff;
  max-width: 471.3pt;
  padding: 71.6pt 68.7pt 74.3pt 72pt;
}

.title {
  padding-top: 24pt;
  color: #000000;
  font-weight: 700;
  font-size: 36pt;
  padding-bottom: 6pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

.subtitle {
  padding-top: 18pt;
  color: #666666;
  font-size: 24pt;
  padding-bottom: 4pt;
  font-family: "Georgia";
  line-height: 1.15;
  page-break-after: avoid;
  font-style: italic;
  orphans: 2;
  widows: 2;
  text-align: left
}

li {
  color: #000000;
  font-size: 11pt;
  font-family: "Arial"
}

p {
  margin: 0;
  color: #000000;
  font-size: 11pt;
  font-family: "Arial"
}

h1 {
  padding-top: 24pt;
  color: #000000;
  font-weight: 700;
  font-size: 24pt;
  padding-bottom: 6pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

h2 {
  padding-top: 18pt;
  color: #000000;
  font-weight: 700;
  font-size: 18pt;
  padding-bottom: 4pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

h3 {
  padding-top: 14pt;
  color: #000000;
  font-weight: 700;
  font-size: 14pt;
  padding-bottom: 4pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

h4 {
  padding-top: 12pt;
  color: #000000;
  font-weight: 700;
  font-size: 12pt;
  padding-bottom: 2pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

h5 {
  padding-top: 11pt;
  color: #000000;
  font-weight: 700;
  font-size: 11pt;
  padding-bottom: 2pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

h6 {
  padding-top: 10pt;
  color: #000000;
  font-weight: 700;
  font-size: 10pt;
  padding-bottom: 2pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}
</style>
